module.exports = __webpack_public_path__ + "static/img/step2.86850030.png";